import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import _502SectionHttpCodesLightReverse1 from '../components/http-codes-light-reverse/_502SectionHttpCodesLightReverse1';

const meta = {
  title: '',
  meta: [],
  link: [],
  style: [],
  script: [],
};

export default function _502() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <_502SectionHttpCodesLightReverse1 />
    </React.Fragment>
  );
}

